import React from 'react';

export default class TheralyticsLoginLogo extends React.Component {
  render() {

    const styles = {
      st0: { fillRule: 'evenodd', clipRule: 'evenodd', fill: '#334196' },
      st1: { fill: '#7285F6' },
      st2: { fill: '#334196' },
    };
    return (<div className="logo">

{/* <svg width="180px" height="30px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           viewBox="0 0 228.9 73.9" style="enable-background:new 0 0 228.9 73.9;" xml:space="preserve"> */}

      <svg width="200px" height="60px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
        viewBox="0 0 228.9 73.9" style={{ enableBackground: 'new 0 0 228.9 73.9' }} >
        <g>
          <path style={styles.st0} d="M179.7,25c0,0-5.2-1.5-7.8-0.3c-3,1.4-4.3,5.2-4.3,5.2S151.9,10,108.7,10C61,10,32.8,35.2,32.8,35.2
            s37-42.6,97.3-34C171.5,7.1,179.7,25,179.7,25z"/>
          <g>
            <path style={styles.st1} d="M19.8,33.2v2.4h-8.4v27.2H8.4V35.6H0v-2.4H19.8z"/>
            <path style={styles.st1} d="M41.7,42c1.7,1.7,2.5,4.2,2.5,7.5v13.4h-2.9V49.7c0-2.5-0.6-4.4-1.9-5.7c-1.3-1.3-3-2-5.2-2
              c-2.3,0-4.1,0.7-5.5,2.2c-1.4,1.5-2,3.6-2,6.5v12.2h-3V31.8h3v13.8c0.6-2,1.7-3.5,3.2-4.5c1.5-1,3.3-1.6,5.3-1.6
              C37.9,39.5,40,40.3,41.7,42z"/>
            <path style={styles.st1} d="M65.6,59.1c1.4-1,2.2-2.4,2.5-4.2h3.1c-0.4,2.4-1.6,4.4-3.5,5.9c-1.9,1.5-4.3,2.3-7.2,2.3
              c-2.2,0-4.1-0.5-5.8-1.4c-1.7-0.9-3-2.3-4-4.1c-1-1.8-1.4-3.9-1.4-6.3s0.5-4.5,1.4-6.3c1-1.8,2.3-3.1,4-4.1
              c1.7-0.9,3.6-1.4,5.8-1.4c2.2,0,4.2,0.5,5.8,1.4c1.6,0.9,2.9,2.2,3.7,3.8c0.9,1.6,1.3,3.3,1.3,5.1c0,0.8-0.1,1.5-0.2,2.1h-19
              c0,1.9,0.4,3.5,1.2,4.9c0.8,1.3,1.8,2.3,3,2.9c1.2,0.6,2.6,0.9,4,0.9C62.5,60.7,64.2,60.2,65.6,59.1z M56.4,42.9
              c-1.2,0.6-2.2,1.6-3,2.8c-0.8,1.3-1.2,2.9-1.2,4.8h16.2c0.1-1.9-0.2-3.5-0.9-4.7c-0.7-1.3-1.7-2.2-2.9-2.9c-1.2-0.6-2.6-0.9-4-0.9
              C59,42,57.7,42.3,56.4,42.9z"/>
            <path style={styles.st1} d="M82.9,40.8c1.5-0.9,3.3-1.3,5.4-1.3v3.2h-1c-2.2,0-4,0.6-5.5,1.8c-1.5,1.2-2.2,3.1-2.2,5.8v12.6h-3V39.9h3
              v4.7C80.3,43,81.4,41.7,82.9,40.8z"/>
            <path style={styles.st1} d="M107.8,41.4c1.6,1.2,2.8,2.8,3.4,4.8v-6.3h2.9v22.9h-2.9v-6.3c-0.6,2-1.7,3.6-3.4,4.8
              c-1.6,1.2-3.6,1.8-5.9,1.8c-2.1,0-3.9-0.5-5.6-1.4c-1.6-1-2.9-2.3-3.8-4.1c-0.9-1.8-1.4-3.9-1.4-6.2c0-2.4,0.5-4.5,1.4-6.3
              c0.9-1.8,2.2-3.1,3.8-4.1c1.6-0.9,3.5-1.4,5.6-1.4C104.2,39.6,106.2,40.2,107.8,41.4z M96.4,44.7c-1.6,1.6-2.3,3.9-2.3,6.7
              s0.8,5.1,2.3,6.7c1.6,1.6,3.6,2.5,6.2,2.5c1.6,0,3.1-0.4,4.4-1.1c1.3-0.8,2.3-1.8,3.1-3.2c0.7-1.4,1.1-3,1.1-4.8
              c0-1.8-0.4-3.4-1.1-4.8c-0.7-1.4-1.8-2.5-3.1-3.2c-1.3-0.8-2.8-1.1-4.4-1.1C100,42.2,98,43,96.4,44.7z"/>
            <path style={styles.st2} d="M125.9,31.8v31.1H120V31.8H125.9z"/>
            <path style={styles.st2} d="M135.2,39.6l6.3,15.8l5.9-15.8h6.5l-14.2,34.4h-6.6l5.2-11.8l-9.8-22.6H135.2z"/>
            <path style={styles.st2} d="M169.2,57.8v5.1h-3.1c-2.6,0-4.6-0.6-6-1.9c-1.4-1.3-2.1-3.4-2.1-6.3V44.6h-3.2v-5h3.2v-5.8h5.9v5.8h5.2v5
              h-5.2v10.2c0,1.1,0.2,1.9,0.7,2.4c0.4,0.4,1.2,0.7,2.3,0.7H169.2z"/>
            <path style={styles.st2} d="M173.8,30.6c0.7-0.6,1.6-0.9,2.6-0.9c1.1,0,2,0.3,2.6,0.9s1,1.4,1,2.3c0,0.9-0.3,1.7-1,2.3
              c-0.7,0.6-1.6,0.9-2.6,0.9c-1.1,0-2-0.3-2.6-0.9c-0.7-0.6-1-1.4-1-2.3C172.7,31.9,173.1,31.2,173.8,30.6z M179.3,39.6v23.3h-5.9
              V39.6H179.3z"/>
            <path style={styles.st2} d="M202.7,41.7c2,1.6,3.3,3.8,3.8,6.6h-6.3c-0.3-1.2-0.8-2.2-1.7-2.9c-0.9-0.7-2-1.1-3.4-1.1
              c-1.6,0-2.9,0.6-3.9,1.7c-1,1.2-1.6,2.9-1.6,5.1s0.5,3.9,1.6,5.1c1.1,1.2,2.4,1.7,3.9,1.7c1.4,0,2.5-0.4,3.4-1.1
              c0.9-0.7,1.5-1.7,1.7-2.9h6.3c-0.5,2.8-1.8,5-3.8,6.6c-2,1.6-4.5,2.4-7.5,2.4c-2.3,0-4.3-0.5-6-1.4c-1.8-1-3.1-2.3-4.1-4.1
              c-1-1.8-1.5-3.9-1.5-6.3c0-2.4,0.5-4.6,1.5-6.4c1-1.8,2.4-3.2,4.1-4.1c1.8-1,3.8-1.4,6-1.4C198.2,39.3,200.7,40.1,202.7,41.7z"/>
            <path style={styles.st2} d="M225.5,41.4c1.7,1.4,2.8,3.3,3.2,5.7h-5.5c-0.2-1.1-0.7-2-1.5-2.7c-0.8-0.7-1.8-1-3.1-1c-1,0-1.8,0.2-2.4,0.7
              c-0.6,0.5-0.8,1.1-0.8,1.9c0,0.6,0.2,1.2,0.7,1.6c0.4,0.4,1,0.7,1.7,0.9c0.7,0.2,1.6,0.5,2.9,0.8c1.8,0.4,3.2,0.8,4.3,1.2
              c1.1,0.4,2.1,1.1,2.9,2.1c0.8,0.9,1.2,2.2,1.2,3.8c0,2-0.8,3.6-2.3,4.8c-1.6,1.2-3.6,1.8-6.3,1.8c-3,0-5.4-0.7-7.3-2
              c-1.8-1.4-2.9-3.3-3.3-5.8h5.7c0.1,1.1,0.6,2.1,1.5,2.7c0.9,0.7,2,1,3.4,1c1,0,1.8-0.2,2.3-0.7c0.5-0.5,0.8-1.1,0.8-1.9
              c0-0.7-0.2-1.2-0.7-1.6c-0.5-0.4-1-0.7-1.7-1c-0.7-0.2-1.7-0.5-2.9-0.8c-1.7-0.4-3.1-0.8-4.2-1.2c-1.1-0.4-2-1.1-2.8-2
              c-0.8-0.9-1.2-2.1-1.2-3.7c0-2,0.8-3.7,2.3-4.9c1.5-1.3,3.7-1.9,6.4-1.9C221.5,39.3,223.7,40,225.5,41.4z"/>
          </g>
        </g>
      </svg>

    </div>);
  }

}



// WEBPACK FOOTER //
// ./src/components/svglogos/LoginLogo/TheralyticsLogo.js